import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../constants/authConfig';

const authService = new PublicClientApplication(msalConfig);

export default authService;
